import * as React from "react";
import { useState, useEffect, useContext, useCallback } from "react";
import {
  AppBar,
  Typography,
  Button,
  Box,
  Breadcrumbs,
  Link,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrn from "../../components/grid/ViewDataGridGrn";
import { ViewApproverGrnData } from "../../components/grid/GridDataGrn";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ApprovalActionDialog from "../../components/grn/grnpopup/ApprovalActionDialog";
import SystemAlert from "../../components/common/SystemAlert";
import FilterGrnSearch from "../../components/grn/FilterGrnSearch";
import { useSelector } from "react-redux";
import { externalgetApi } from "../../services/externalApis";
import { GRN_API_02_2 } from "../../api/ApiModel";
import { FormatDate } from "../../utils/common/DateUtils";
import Switch from '@mui/material/Switch';
import { AnyForNow, GrnFilterState } from "./types";

import {
  BUTTON_LABELS,
  GRN_BREADCRUMBS,
  GRN_SECTIONS,
} from "../../utils/sys/GrnLabels";
import { GRN_SUCCESS_MESSAGES, GRN_ERROR_MESSAGES } from "../../utils/sys/GrnValidation";
import { GRN_ROUTES } from "../../utils/sys/GrnRoutes";
import {
  createInitialFilters,
  useGrnStatusTypes,
  useWarehouseOptions,
} from "./hooks/useGrnFilters";
import { useAlertQueue } from "../../hooks/useAlertQueue";
import {
  GRN_APPROVER_FILTER,
  GRN_APPROVER_STATUS,
} from "../../utils/sys/GrnConstants";

const ViewApproverGrn: React.FC = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);

  useEffect(() => {
    setPageData({
      title: GRN_SECTIONS.MANAGEMENT_TITLE,
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, [setPageData]);
  const [selectedIds, setSelectedIds] = useState<AnyForNow[]>([]);
  const [openRejectDialog, setOpenRejectDialog] = useState<boolean>(false);
  const [openApproveDialog, setOpenApproveDialog] = useState<boolean>(false);
  const [openReturnDialog, setOpenReturnDialog] = useState<boolean>(false);
  const { alertState, showAlert, handleClose: handleAlertClose } = useAlertQueue();
  const { open: alertOpen, type: alertType, message: alertMessage } = alertState;
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { STAFFMAPLOCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const [allfullData, setAllfullData] = useState<AnyForNow[]>([]);
   const [filteredfullRows, setFilteredfullRows] = useState<AnyForNow[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  // Inside ViewApproverGrn
  const [checked, setChecked] = React.useState<boolean>(false);
  const [selectedGrnCode, setSelectedGrnCode] = useState<string[]>([]);
  const showSuccess = (msg: string): void => {
    showAlert(msg, "success");
  };

  // Button click handler
  const handleApproveClick = (): void => {
    if (selectedIds.length === 0) {
      showError(GRN_ERROR_MESSAGES.SELECT_AT_LEAST_ONE_GRN);
      return
    }
    // setSelectedGrnCode(selectedIds[0]);
    setOpenApproveDialog(true);
  };
  const handleRejectClick = (): void => {
    if (selectedIds.length === 0) {
      showError(GRN_ERROR_MESSAGES.SELECT_AT_LEAST_ONE_GRN);
      return;
    }
    // setSelectedGrnCode(selectedIds[0]);
    setOpenRejectDialog(true);
  };

  const handleReturnClick = (): void => {
    if (selectedIds.length === 0) {
      showError(GRN_ERROR_MESSAGES.SELECT_AT_LEAST_ONE_GRN);
      return;
    }
    // setSelectedGrnCode(selectedIds[0]);
    setOpenReturnDialog(true);
  };

  // const handleRowSelection = (ids) => {
  //   setSelectedIds(ids);

  //   if (ids.length === 1) {
  //     const selectedRow = filteredRows.find((row) => row.id === ids[0]);
  //     if (selectedRow) {
  //       setSelectedGrnCode(selectedRow.grncode);
  //     }
  //   } else {
  //     setSelectedGrnCode("");
  //   }
  // };

const handleRowSelection = (ids: AnyForNow[]): void => {
  if (!ids.length) {
    setSelectedIds([]);
    setSelectedGrnCode([]);
    return;
  }

  // Find all selected rows
  const selectedRows = filteredRows.filter((row) => ids.includes(row.id));

  // Get the trsts of the first selected row
  const firstStatus = selectedRows[0]?.trsts;

  // Check if all selected rows share the same trsts
  const allSameStatus = selectedRows.every((row) => row.trsts === firstStatus);

  if (!allSameStatus) {
    // Block selection of rows with mixed status
    console.warn("Selection blocked: Different status (trsts) detected.");
    showError(GRN_ERROR_MESSAGES.SELECT_SAME_STATUS);

    // Revert to previously valid selection
    return;
  }

  // Allowed â€” update selected rows and GRN codes
  setSelectedIds(ids);
  setSelectedGrnCode(selectedRows.map((row) => row.grncode));
};



  const [filteredRows, setFilteredRows] = useState<AnyForNow[]>([]);
  const warehouseOptions = useWarehouseOptions(COMPCODE);
  const statusFilter = useCallback(
    (item: AnyForNow) =>
      String(item.trcatcode) === GRN_APPROVER_FILTER.TRCATCODE &&
      String(item.trsts) !== GRN_APPROVER_FILTER.EXCLUDED_STATUS,
    []
  );
  const initialVisibleStatuses =
    GRN_APPROVER_FILTER.INITIAL_VISIBLE_STATUSES as readonly string[];

  const { statusTypes: grnStatusTypes } = useGrnStatusTypes({
    filter: statusFilter,
    mapStatus: (item) => ({
      ...item,
      grnstatus: item.trappuserremark,
      grnstatuscode: item.trsts,
      colorcode: item.colorcode || GRN_APPROVER_FILTER.STATUS_COLOR_FALLBACK,
    }),
    deps: [statusFilter],
  });
  const [filters, setFilters] = useState<GrnFilterState>(createInitialFilters());
  const showError = (msg: string): void => {
    showAlert(msg, "error");
  };

  const handleItemClick = (grncode: string, trsts: string, actionText: string): void => {
    if (actionText === BUTTON_LABELS.VIEW) {
      navigate(GRN_ROUTES.VIEW_DETAIL, {
        state: { grncode, trsts, origin: GRN_APPROVER_FILTER.ORIGIN },
      });
    } else if (actionText === BUTTON_LABELS.EDIT) {
      navigate(GRN_ROUTES.EDIT, { state: { grncode, trsts } });
    }
  };

  // Refs to prevent duplicate API calls
  const hasFetchedGrnListRef = React.useRef(false);
  const grnStatusTypesRef = React.useRef<AnyForNow[]>([]);
  const isInitialLoadRef = React.useRef(true);

  // Update ref when grnStatusTypes changes
  React.useEffect(() => {
    grnStatusTypesRef.current = grnStatusTypes;
  }, [grnStatusTypes]);

  // Consolidated: Single API call that processes data for both filtered and full lists
  const fetchGrnListData = useCallback(async (forceRefresh = false): Promise<void> => {
    if (!COMPCODE || !STAFFMAPLOCODE) {
      return;
    }

    // Prevent duplicate calls unless forced refresh
    if (hasFetchedGrnListRef.current && !forceRefresh) {
      return;
    }

    try {
      hasFetchedGrnListRef.current = true;
      setLoading(true);

      // Single API call instead of two duplicate calls
      const result = await externalgetApi(GRN_API_02_2, "GET", {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
      });

      if (!Array.isArray(result)) {
        setAllfullData([]);
        setFilteredRows([]);
        setLoading(false);
        return;
      }

      // Filter out items with trsts = "2"
      const filteredResult = result.filter(
        (item) => String(item.trsts) !== GRN_APPROVER_FILTER.EXCLUDED_STATUS
      );

      // Process data once and create both filtered versions
      const rowsWithId = filteredResult.map((item, index) => {
        const matchedStatus = grnStatusTypesRef.current.find(
          (status) => String(status.trsts) === String(item.trsts)
        );

        return {
          ...item,
          id: item.grncode || index,
          invoicedate: FormatDate(item.invoicedate) || null,
          endate: FormatDate(item.endate) || null,
          statusLabel: matchedStatus?.trappuserremark || GRN_BREADCRUMBS.STATUS_FALLBACK,
          statusColor:
            matchedStatus?.colorcode || GRN_APPROVER_FILTER.STATUS_COLOR_FALLBACK,
          invoicedateRaw: item.invoicedate, // for filtering
          endateRaw: item.endate,
          pocode: item.pocode,
          grnstatuscode: item.trsts,
        };
      });

      // Set full data (all statuses except "2")
      setAllfullData(rowsWithId);

      // Filter for initial display (only statuses "1" and "3")
      const initialFiltered = rowsWithId.filter((item) =>
        initialVisibleStatuses.includes(String(item.trsts))
      );

      setFilteredRows(initialFiltered);
    } catch (err) {
      console.error("Error fetching GRN list data:", err);
      hasFetchedGrnListRef.current = false; // Reset on error to allow retry
    } finally {
      setLoading(false);
    }
  }, [COMPCODE, STAFFMAPLOCODE]);

  // Initial load - only fetch when status types are loaded
  useEffect(() => {
    if (grnStatusTypes.length > 0 && isInitialLoadRef.current && COMPCODE && STAFFMAPLOCODE) {
      isInitialLoadRef.current = false;
      fetchGrnListData();
    }
  }, [fetchGrnListData, grnStatusTypes.length, COMPCODE, STAFFMAPLOCODE]);

  // Handle switch toggle - filter existing data instead of re-fetching
  useEffect(() => {
    if (!checked && allfullData.length > 0) {
      // When switch is off, show only statuses "1" and "3"
      const filtered = allfullData.filter((item) =>
        initialVisibleStatuses.includes(String(item.trsts))
      );
      setFilteredRows(filtered);
    } else if (checked && allfullData.length > 0) {
      // When switch is on, show all data (already filtered to exclude "2")
      setFilteredRows(allfullData);
    }
  }, [checked, allfullData]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      const isChecked = event.target.checked;
      setChecked(isChecked);
      // No need to fetch - useEffect above will handle filtering
    },
    []
  );

  const isFilterApplied = Object.values(filters).some(
  (val) => val !== null && val !== "" 
);

useEffect(() => {
  if (!allfullData.length) {
    setFilteredfullRows([]);
    return;
  }

  let filtered = allfullData;

  if (filters.grnId) {
    const search = filters.grnId.toLowerCase();
    filtered = filtered.filter((item) =>
      item.grncode.toString().toLowerCase().includes(search)
    );
  }

if (filters.warehouse) {
  filtered = filtered.filter(
    (item) => String(item.restcode) === String(filters.warehouse)
  );
}


  if (filters.status) {
    filtered = filtered.filter(
      (item) => String(item.grnstatuscode) === String(filters.status)
    );
  }

 if (filters.fromDate && filters.toDate) {
  const from = new Date(filters.fromDate);
  const to = new Date(filters.toDate);

  const start = from < to ? from : to;
  const end = from < to ? to : from;

  filtered = filtered.filter(
    (item) => {
      const date = new Date(item.invoicedateRaw || item.endateRaw);
      return date >= start && date <= end;
    }
  );
} else if (filters.fromDate) {
  const from = new Date(filters.fromDate);
  filtered = filtered.filter(
    (item) => new Date(item.invoicedateRaw) >= from
  );
} else if (filters.toDate) {
  const to = new Date(filters.toDate);
  filtered = filtered.filter(
    (item) => new Date(item.endateRaw) <= to
  );
}


  setFilteredfullRows(filtered);
}, [filters, allfullData]);

  const handleFilterChange = (newFilters: GrnFilterState): void => {
    setFilters(newFilters);
  };
  const menuItems = [
    {
      text: BUTTON_LABELS.VIEW,
      icon: <VisibilityOutlinedIcon />,
      onClick: (row: AnyForNow) => handleItemClick(row.grncode,row.trsts, BUTTON_LABELS.VIEW),
    },
  ];

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
        <Breadcrumbs
          separator={GRN_BREADCRUMBS.SEPARATOR}
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.HOME}
          </Link>
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.GRN}
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
            {GRN_SECTIONS.MANAGEMENT_TITLE}{" "}
          </Link>
        </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.vg_appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {ViewApproverGrnData.name}
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }}>
        <Box
  sx={{
    gap: 1,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
  }}
>
  {(() => {
    const selectedRows = filteredRows.filter((row) =>
      selectedIds.includes(row.id)
    );
    const hasStatus1 = selectedRows.some(
      (row) => String(row.trsts) === GRN_APPROVER_STATUS.RETURN_ALLOWED
    );
    const hasStatus3 = selectedRows.some(
      (row) => String(row.trsts) === GRN_APPROVER_STATUS.APPROVE_REJECT_ALLOWED
    );

    return (
      <>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ ...styles.btn_primary }}
          onClick={handleReturnClick}
          disabled={!hasStatus1}
        >
          {BUTTON_LABELS.RETURN}
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ ...styles.btn_primary }}
          onClick={handleRejectClick}
          disabled={!hasStatus1 && !hasStatus3}
        >
          {BUTTON_LABELS.REJECT}
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ ...styles.btn_primary }}
          onClick={handleApproveClick}
          disabled={!hasStatus1 && !hasStatus3}
        >
          {BUTTON_LABELS.APPROVE}
        </Button>
      </>
    );
  })()}

  <Switch
    checked={checked}
    onChange={handleChange}
    inputProps={{ "aria-label": GRN_APPROVER_FILTER.SWITCH_ARIA_LABEL }}
  />
</Box>


            </Grid>
            {/* <Grid
              size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}
              sx={styles.vg_grid_new_button}
            >
              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={goToCreateGrn}
              >
                New
              </Button>
            </Grid> */}
          </Grid>
        </AppBar>
        <FilterGrnSearch
          warehouseOptions={warehouseOptions}
          grnStatusTypes={grnStatusTypes}
          onFilterChange={handleFilterChange}
        />

        <Box sx={styles.view_page_container}>
          <ViewDataGridGrn
            columns={ViewApproverGrnData.columns}
         rows={isFilterApplied ? filteredfullRows : filteredRows}
            menuItems={menuItems}
            // statusOptions={statusOptions}
            tabletitle={ViewApproverGrnData.name}
            gridid={GRN_APPROVER_FILTER.GRID_ID}
            {...({sx: styles.view_data_grid_page} as any)}
            onSelectionChange={handleRowSelection}
            grnStatusTypes={grnStatusTypes}
            selectionModel={selectedIds}
            disableMultipleSelection
            loading={loading}
          />
        </Box>
      </Box>

      <ApprovalActionDialog
        open={openApproveDialog}
        handleClose={() => setOpenApproveDialog(false)}
        actionType={BUTTON_LABELS.APPROVE}
        grnCodes={selectedGrnCode}
        enUser={USERNAME}
        onSuccess={() => {
          fetchGrnListData(true); // Refresh data after status change (force refresh)
          setOpenApproveDialog(false);
          setSelectedIds([]);
          setSelectedGrnCode([]);
          showSuccess(GRN_SUCCESS_MESSAGES.APPROVE_SUCCESS);
        }}
      />
      <ApprovalActionDialog
        open={openReturnDialog}
        handleClose={() => setOpenReturnDialog(false)}
        actionType={BUTTON_LABELS.RETURN}
        grnCodes={selectedGrnCode}
        enUser={USERNAME}
        onSuccess={() => {
          fetchGrnListData(true); // Refresh data after status change (force refresh)
          setOpenReturnDialog(false);
          setSelectedIds([]);
          setSelectedGrnCode([]);
          showSuccess(GRN_SUCCESS_MESSAGES.RETURN_SUCCESS);
        }}
      />
      <ApprovalActionDialog
        open={openRejectDialog}
        handleClose={() => setOpenRejectDialog(false)}
        actionType={BUTTON_LABELS.REJECT}
        grnCodes={selectedGrnCode}
        enUser={USERNAME}
        onSuccess={() => {
          fetchGrnListData(true); // Refresh data after status change (force refresh)
          setOpenRejectDialog(false);
          setSelectedIds([]);
          setSelectedGrnCode([]);
          showSuccess(GRN_SUCCESS_MESSAGES.REJECT_SUCCESS);
        }}
      />
      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        onClose={handleAlertClose}
      />
    </>
  );
};

export default ViewApproverGrn;
